import { UserRole } from 'v2/constants/user-roles'
import { useAuth } from 'react-oidc-context'

/**
 * Check if the current user has any of the specified roles
 * @param checkRoles Array of roles to check against the user's roles
 * @returns boolean indicating if the user has any of the specified roles
 */
export const useCheckUserRole = (checkRoles: UserRole[]): boolean => {
	const { user } = useAuth()
	if (!user) return false

	const userRoles = user.profile.role
	let sanitizedUserRoles: UserRole[] = []

	if (Array.isArray(userRoles)) {
		sanitizedUserRoles = userRoles
	} else if (typeof userRoles === 'string') {
		sanitizedUserRoles = [userRoles as UserRole]
	}

	return sanitizedUserRoles.some((role) => checkRoles.includes(role))
}
